import Swal from 'sweetalert2';
import authHelper from './helpers/authHelper';
import { axiosErrorHandler, axiosResponseHandler, callTheApServerPost } from './helpers/axiosHelper';
import { hydrateApBasicData } from './helpers/basicHelper';
import { byId } from './helpers/utility';





authHelper.validate();
hydrateApBasicData();
// checking query params for transition result alert






const messageInput = byId('messageInput');
const pushNotificationSendBtn = byId('pushNotificationSendBtn');







const pushWebApkNotificationFun = () => {
    const data = {
        message: messageInput.value,
        
       
    };
    callTheApServerPost(`/basic/pushWebApkNotification`, { data: data }).then((response) => {
        axiosResponseHandler(response);
        const res = response.data;






        if (res.status === 'success') {
            console.log(res);


            Swal.fire({
                title: 'Notification Sended',
                icon: 'success',
              


            });

           



        }
    }).catch((error) => {
        axiosErrorHandler(error);
        console.log(error);
    });
};

pushNotificationSendBtn.addEventListener('click', pushWebApkNotificationFun);










